import state from './File/states'
import mutations from './File/mutations'
import actions from './File/actions'
import getters from './File/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
